export default {
    "setVipStatusOpt": "78adcb62f96c45ea0aab71377b2732e2f16d4bf42eba23e5002de42ac5f848ca",
    "isEmailAvailable": "3191da0fbc8493f80c62019b9f24547bc145e7d37f869764d31047d61da8b0b6"
};
